// Note: The first file of a module here, must also register the module

import "./canvass-activity.helper";
import "./canvass-form.component";
import "./canvass-list.component";

import "./modals";
